export default "__VITE_ASSET__D_u3fkjI__"